import Header from '../partials/common/header/header';
import Footer from '../partials/common/footer/footer';
import Destinations from "../partials/home/destinations";

function DestinationsPage() {
    return (
        <>
            <Header/>
            <Destinations/>
            <Footer/>
        </>
    );
}

export default DestinationsPage;